/**
 * Ads
 */
export const AD_IMPRESSION = 'executedAdImpression'
export const AD_ACTION = 'executedAdAction'

/**
 * Orders
 */
export const POST_ORDER_AD_SEEN_KEY = 'didSeePostOrderAd'
export const NEXT_ROUND_ORDER_KEY = 'nextRoundOrder'
